import { render } from "./codes.vue?vue&type=template&id=4dc922e4"
import script from "./codes.vue?vue&type=script&lang=js"
export * from "./codes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/onlyfoodies-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__